import { GET_ALL_LANGUAGES, GET_SINGLE_LANGUAGE_DATA } from "./actionTypes";

const initialState = {
    languages: [],
    language: []
};

export default function(state = initialState, action) {
    switch (action.type) {
        case GET_ALL_LANGUAGES:
            return { ...state, languages: Array.isArray(action.payload) ? action.payload : [] };
        case GET_SINGLE_LANGUAGE_DATA:
            // Store language data in localStorage
            if (Array.isArray(action.payload)) {
                action.payload.forEach(item => {
                    if (item.key && item.value) {
                        localStorage.setItem(item.key, item.value);
                    }
                });
            }
            return { ...state, language: Array.isArray(action.payload) ? action.payload : [] };
        default:
            return state;
    }
}
